import { Modal, Button } from '@plick/ui';
import type { ConnectionModalProps } from '@interfaces/Integration';

export const WhatsappQrModal = ({ isOpen, qrCode, onVerify, onClose, isVerifying }: ConnectionModalProps) => {
  return (
    <Modal padding="0" isOpen={isOpen} onClose={onClose}>
      <div className="p-6">
        <div className="flex flex-col items-center max-w-md mx-auto">
          <h2 className="text-2xl font-bold text-color-primary mb-4">CONECTAR WHATSAPP</h2>

          <div className="bg-color-white rounded-lg shadow-sm w-full">
            <div className="flex flex-col items-center">
              {qrCode ? (
                <img src={qrCode} alt="Código QR WhatsApp" className="w-64 h-64 mb-4" />
              ) : (
                <div className="w-64 h-64 flex items-center justify-center bg-color-gray_light rounded-lg">
                  <p className="text-color-gray-dark">Cargando código QR...</p>
                </div>
              )}
            </div>
          </div>

          <div className="bg-color-surface_faded p-4 rounded-lg mb-4 w-full">
            <h3 className="font-semibold text-color-secondary mb-2">Cómo conectar:</h3>
            <ol className="list-decimal list-inside text-sm text-color-gray-dark space-y-1">
              <li>Abre WhatsApp en tu teléfono</li>
              <li>Ve a Ajustes &gt; Dispositivos vinculados</li>
              <li>Toca &quot;Vincular un dispositivo&quot;</li>
              <li>Escanea el código QR de arriba</li>
              <li>Haz clic en &quot;Ya lo escaneé&quot; cuando termines</li>
            </ol>
          </div>
        </div>
      </div>

      <div className="sticky bottom-0 left-0 right-0 bg-color-white border-t border-color-gray-light">
        <div className="flex gap-3 justify-end p-6">
          <Button.Secondary text="CANCELAR" onClick={onClose} disabled={isVerifying} />
          <Button.Primary
            text="YA LO ESCANEÉ"
            onClick={onVerify}
            isLoading={isVerifying}
            disabled={isVerifying || !qrCode}
          />
        </div>
      </div>
    </Modal>
  );
};
